import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';
import { imagePropTypes } from '../../../propTypes';
import Icon from '../Atoms/Icon';
import Carousel from '../Carousel';

const propTypes = exact({
  handleModalClose: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  carouselImages: PropTypes.arrayOf(imagePropTypes),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
});

const defaultProps = {
  title: '',
  carouselImages: [],
};

function Modal({ handleModalClose, modalIsOpen, title, carouselImages, children }) {
  return modalIsOpen ? (
    <div className="Modal">
      <button className="Modal_close" type="button" onClick={() => handleModalClose()}>
        <Icon id="cross" blockName="Modal_closeIcon" />
      </button>
      <div className="Modal_inner">
        <div className="Modal_container">
          {carouselImages.length > 0 && (
            <div className="Modal_images">
              <Carousel items={carouselImages} sideButtons />
            </div>
          )}
          <h2 className="Modal_title">{title}</h2>
          <div className="Modal_body">{children}</div>
        </div>
      </div>
    </div>
  ) : null;
}

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;
